import React, { useEffect, useRef, useState } from "react";
import { MessageType } from "../../constants";
// import "../../modal.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo from '../../static/images/sbilife-logo.png'
import { numDifferentiation } from "../../utils";

export default function HealthPlanFeaturesPopup({ content, closePlanFeaturePopup, message, openModal }) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // if (isMobile) {
    //   /* your code here */
    // }
    const [activeLink, setActiveLink] = useState("Highlights")
    console.log(isMobile)
    const settings = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: true,

        responsive: [
            {
                breakpoint: 570,
                settings: "unslick"
            }
        ],

    };

    const scrollDown = (id) => {
        document.getElementById(id).scrollIntoView();
        setActiveLink(id)
    };
    const handleClick = event => {
        event.currentTarget.classList.toggle('active');
    };


    return (
        // <div id="popup1" className={`overlay  ${openModal}`}>
        <div class="planfeatures">

            <div class="plans">
                <span class="closebtn" onClick={() => closePlanFeaturePopup()}>&#x2715; </span>
                {content && content.plan_info ?
                    <div class="plan_type">

                        <div class="planinfo">
                            <div class="logo"><img src={content.plan_info.ImageUrl} /></div>
                            <div class="plan_name">{content.plan_info.plan_name}</div>
                        </div>
                        {content.plan_info.sum_insured && content.plan_info.final_premium ?
                            <div class="benifit">
                                <div class="cover"> Cover <span>{numDifferentiation(content.plan_info.sum_insured)}</span> </div>
                                <div class="premium"> Premium <span>{content.plan_info.final_premium.toLocaleString('en-IN')}/Year</span> </div>
                                {/* <div class="download">Download <span>Brocuhre</span> </div> */}
                            </div>
                            : null}
                    </div>
                    : null}

            </div>
            <div class="planfeatures_wrap">
                {isMobile ? null :
                    <>
                        <div className="leftshadow"></div>
                        <div className="rightshadow"></div>
                    </>
                }
                <Slider className={`tabs ${isMobile ? "isShadow" : null}`} {...settings} >
                    {content && content.features ? Object.keys(content.features).map((item) =>
                        // <div class="tabs">
                        <div key={item} className={`item ${item === activeLink ? "active" : null}`} onClick={() => scrollDown(item)} >{item}</div>

                        // </div>
                    ) : null
                    }
                </Slider >
            </div >

            <div class="planfeatures_content">
                {content && content.features ? Object.keys(content.features).map((item) =>
                    <div id={item} key={item}>
                        <>
                            <div class="feautes-list titleItem">
                                {item}
                            </div>
                            {content && content.features && content.features[item] ? content.features[item].map((feature) =>
                                <div class="feautes-list" key={feature} onClick={(event) => handleClick(event)}>
                                    <span class={`heading`}><i className={`${feature.feature_text === "Not available in this plan" ? "close" : null}`}></i>{feature.feature_short_name}</span>
                                    {feature.feature_importance ?
                                        <>
                                            <span class="text">{feature.feature_text}</span>
                                            <div class="acc_content">
                                                <span class="acc_heading">What you should know</span>
                                                <span class="acc_text">{feature.feature_importance}</span>
                                            </div>
                                        </>
                                        : <div class="acc_content">
                                            <span class="text">{feature.feature_text}</span>

                                        </div>}
                                </div>
                            ) : null}
                        </>
                    </div>
                ) : null}
            </div>
        </div >
        // </div>
    );
}
